export interface TypeName {
  __typename: string;
}


export interface Traceable {
  creationTime: string;
  updatedTime: string;
}
